import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { PermissionsActionAddPayload, PermissionsActionUpdatePayload } from './permissions-action-admin.interface';

@Injectable({
  providedIn: 'root'
})
export class PermissionsActionAdminService {
  private basePath = environment.interop.basePath;
  private getPermissionsActionDT = this.basePath + environment.interop.platform.nomenclatoare.permissionActions.getPermissionActionsDT;
  private token!: string;
  private httpOptions: any;
  private storePermissionsActionURL = this.basePath + environment.interop.platform.nomenclatoare.permissionActions.storePermissionAction;
  private updateStorePermissionsAction = this.basePath + environment.interop.platform.nomenclatoare.permissionActions.putPermissionAction;
  private deletePermissionsActions = this.basePath + environment.interop.platform.nomenclatoare.permissionActions.deletePermissionAction;
  private getPermissionsActionActive = this.basePath + environment.interop.platform.nomenclatoare.permissionActions.getPermissionActionsActive;
  private getPermissionsActionPublic = this.basePath + environment.interop.platform.nomenclatoare.permissionActions.getPermissionActionsActivePublic;
  constructor(private http: HttpClient) { }

  getPermissionsActionsDT() {
    return this.http.get(this.getPermissionsActionDT, this.httpOptions);
  }

  addPermissionsAction(permissionsAction: PermissionsActionAddPayload) {
    return this.http.post(this.storePermissionsActionURL, permissionsAction, this.httpOptions);
  }

  updatePermissionsAction(permissionsAction: PermissionsActionUpdatePayload) {
    return this.http.put(this.updateStorePermissionsAction, permissionsAction, this.httpOptions);
  }

  deletePermissionsAction(permissionsActionId: number) {
    return this.http.delete(this.deletePermissionsActions + permissionsActionId);
  }

  getActivePermissionsAction() {
    return this.http.get(this.getPermissionsActionActive, this.httpOptions);
  }

  getPublicPermissionsAction() {
    return this.http.get(this.getPermissionsActionPublic, this.httpOptions);
  }

  setToken(token: string) {
    this.token = token;
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `Bearer ${this.token}`,
      }),
    };
  }
}
